module.exports = __webpack_public_path__ + "media/images/6-75c64efca837ac1b6d95d5990e3a08f9.jpg";